import React from 'react';
import PropTypes from 'prop-types';
import { BulkSelectionContext } from './BulkSelection';
export const BulkSelectionConsumer = ({ consumerCompName = 'BulkSelectionConsumer', providerCompName = 'BulkSelection', children, }) => {
    return (React.createElement(BulkSelectionContext.Consumer, null, context => {
        return children(context);
    }));
};
BulkSelectionConsumer.propTypes = {
    children: PropTypes.any,
    consumerCompName: PropTypes.string,
    providerCompName: PropTypes.string,
};
//# sourceMappingURL=BulkSelectionConsumer.js.map